import React from 'react';
import ModalBase from '../ModalBase';

function Item({ show, onClose, data = {} }) {
  const renderDataRows = () =>
    Object.entries(data).map(([key, value]) => (
      <div key={key} style={rowStyle}>
        <span style={labelStyle}>{key}</span>
        <span style={valueStyle}>{value}</span>
      </div>
    ));

  return (
    <ModalBase show={show} onClose={onClose}>
      <div style={modalContainerStyle}>
        <div style={headerStyle}>
          <div style={iconWrapperStyle}>
            <span style={checkmarkStyle}>✓</span>
          </div>
          <h2 style={titleStyle}>Compra realizada com sucesso</h2>
        </div>

        <div style={contentStyle}>{renderDataRows()}</div>

        <button onClick={onClose} style={buttonStyle}>
          Ok
        </button>
      </div>
    </ModalBase>
  );
}

// Styles
const modalContainerStyle = {
  backgroundColor: '#fff',
  padding: '0 2.5rem',
  borderRadius: '12px',
  maxWidth: '600px',
  margin: '0 auto',
};

const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '1.5rem',
};

const iconWrapperStyle = {
  width: '24px',
  height: '24px',
  backgroundColor: '#1c787e',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '0.5rem',
};

const checkmarkStyle = {
  color: '#fff',
  fontWeight: 'bold',
};

const titleStyle = {
  fontSize: '20px',
  fontWeight: '500',
  textAlign: 'center',
};

const contentStyle = {
  lineHeight: '1.8',
  fontSize: '14px',
};

const rowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  padding: '4px 0',
  borderBottom: '1px solid #e0e0e0',
};

const labelStyle = {
  color: '#888',
  fontWeight: '400',
  width: '35%',
};

const valueStyle = {
  fontWeight: '500',
  textAlign: 'right',
  width: '65%',
};

const buttonStyle = {
  marginTop: '2rem',
  width: '100%',
  padding: '12px',
  backgroundColor: '#1c787e',
  color: '#fff',
  fontSize: '16px',
  fontWeight: '500',
  borderRadius: '8px',
  border: 'none',
  cursor: 'pointer',
};

export default Item;
